import { HtmlDiv } from 'htmlmodule'
import './Backdrop.css'

export class Backdrop extends HtmlDiv
{
  static class = 'Backdrop'
}
